(() => {
  'use strict';
  const widgets = document.querySelectorAll('[data-ct-public-reviews]');
  widgets.forEach((widget) => {
    const section = widget.closest('section');
    const status = section.querySelector('[role="status"]');
    const retry = section.querySelector('.ct-public-reviews__retry');
    let busy = false;
    async function load(page = 1) {
      if (busy) return;
      busy = true;
      widget.setAttribute('aria-busy', 'true');
      retry.hidden = true;
      try {
        if (!window.jdgm?.shopParams || !window.jdgm?.SPECIAL_CDN_HOST_HTTPS) throw new Error('Review service unavailable');
        const endpoint = new URL('/reviews/reviews_for_widget', window.jdgm.SPECIAL_CDN_HOST_HTTPS);
        endpoint.search = new URLSearchParams({...window.jdgm.shopParams(), product_id: widget.dataset.id, page, per_page: 20, legacy_widget: true});
        const response = await fetch(endpoint, {signal: AbortSignal.timeout(15000)});
        if (!response.ok) throw new Error('Review service response ' + response.status);
        const result = await response.json();
        if (typeof result.html !== 'string') throw new Error('Unexpected review response');
        let body = widget.querySelector('.jdgm-rev-widg__body');
        if (!body) { body = document.createElement('div'); body.className = 'jdgm-rev-widg__body'; widget.append(body); }
        body.innerHTML = result.html;
        window.jdgm.customizeReviews?.();
        status.hidden = true;
        if (!body.querySelector('.jdgm-rev') && Number(result.total_count) === 0) section.hidden = true;
      } catch (error) {
        status.textContent = 'Reviews could not load. Please try again.';
        status.hidden = false;
        retry.hidden = false;
      } finally { busy = false; widget.removeAttribute('aria-busy'); }
    }
    retry.addEventListener('click', () => load());
    widget.addEventListener('click', (event) => {
      const link = event.target.closest('.jdgm-paginate__page[data-page]');
      if (!link) return;
      const page = Number(link.dataset.page);
      if (!Number.isInteger(page) || page < 1) return;
      event.preventDefault();
      event.stopImmediatePropagation();
      load(page);
    }, true);
    const observer = new IntersectionObserver((entries) => {
      if (!entries.some(e => e.isIntersecting)) return;
      observer.disconnect();
      let attempts = 0;
      const ready = () => {
        if (window.jdgm?.shopParams && window.jdgm?.SPECIAL_CDN_HOST_HTTPS) load();
        else if (++attempts < 40) setTimeout(ready, 500);
        else { status.hidden = false; status.textContent = 'Reviews could not load. Please try again.'; retry.hidden = false; }
      };
      ready();
    }, {rootMargin: '600px'});
    observer.observe(widget);
  });
})();
